var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTiktok(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.378 2.156c.156 1.283.587 2.293 1.287 2.994.681.682 1.637 1.085 2.855 1.159a.51.51 0 0 1 .481.508v3.136c0 .279-.225.508-.506.508a6.08 6.08 0 0 1-2.436-.267c-.537-.167-1.074-.403-1.63-.694v4.983c0 2.362-.787 4.252-1.98 5.579-.874.973-1.961 1.649-3.129 1.996s-2.411.372-3.585.031c-1.443-.415-2.78-1.37-3.729-2.913-.606-.985-.956-2.176-.999-3.384-.037-1.116.175-2.256.681-3.285.512-1.035 1.312-1.965 2.436-2.647 1.099-.669 2.511-1.097 4.26-1.159.281-.012.518.211.531.49v3.322c0 .267-.206.483-.469.508l-.743.149c-.244.056-.481.124-.712.205-.656.217-1.162.527-1.462.942-.294.403-.412.936-.312 1.63.131.936.843 1.643 1.687 1.928.35.118.718.167 1.074.13.35-.037.687-.155.987-.366.762-.539 1.281-1.705 1.124-3.694V2.175c0-.279.231-.508.512-.508h3.267a.51.51 0 0 1 .512.477v.012z",
    fill: "#222"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTiktok);
export default __webpack_public_path__ + "static/media/tiktok.d77d21698d308fd6d533d3d50ca184f0.svg";
export { ForwardRef as ReactComponent };